import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'fcp-radio',
    templateUrl: './fcp-radio.component.html',
    styleUrls: ['./fcp-radio.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FcpRadioComponent),
            multi: true
        }
    ],
    standalone: false
})
export class FcpRadioComponent implements ControlValueAccessor {
    @Input() options: FcpRadioOption[] = [];
    @Input() position: 'row' | 'column' = 'column';
    value: string;
    onChange: any = () => {};
    onTouched: any = () => {};

    writeValue(value: string): void {
        this.value = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        // implement if you want to handle disabling
    }

    updateValue(option: { value: string; label: string; checked: boolean }) {
        this.value = option.value;
        this.onChange(this.value);
        this.onTouched();
    }
}

export type FcpRadioOption = { value: any; label: string; checked: boolean; disabled?: boolean; description?: string };
